import React from "react";
import Image from "next/image";
import styles from "./index.module.scss";

export function AnimationHome() {
  return (
    <Image
      loading="lazy"
      src="/images/animation/person-home.svg"
      alt="person-home.svg"
      width="418"
      height="458"
      className={styles.home}
    />
  );
}

export function AnimationChecker() {
  return (
    <Image
      loading="lazy"
      src="/images/animation/apple-receipt-checker.svg"
      alt="apple-receipt-checker.svg"
      width="484"
      height="448"
    />
  );
}

export function AnimationCalendar() {
  return (
    <Image
      loading="lazy"
      src="/images/animation/apple-fiscal-calendar.svg"
      alt="apple-fiscal-calendar.svg"
      width="608"
      height="490"
    />
  );
}

export function AnimationMetrics() {
  return (
    <Image
      loading="lazy"
      src="/images/animation/img2.svg"
      alt="img2.svg"
      width="608"
      height="490"
      className={styles.metrics}
    />
  );
}

export function AnimationSubscribers() {
  return (
    <Image
      loading="lazy"
      src="/images/animation/img.svg"
      alt="img.svg"
      width="488"
      height="360"
    />
  );
}

export function AnimationMakingInApp() {
  return (
    <Image
      loading="lazy"
      src="/images/animation/making-in-app.svg"
      alt="making-in-app.svg"
      width="488"
      height="360"
    />
  );
}

export function AnimationChart() {
  return (
    <Image
      loading="lazy"
      src="/images/animation/chart.svg"
      alt="chart.svg"
      width="1008"
      height="476"
      className={styles.charts}
    />
  );
}

export function AnimationInHouse() {
  return (
    <Image
      loading="lazy"
      src="/images/animation/inhouse1.svg"
      alt="inhouse1.svg"
      width="488"
      height="360"
      className={styles.inHouse}
    />
  );
}
